export const COMPUTED_VALUE = "<computed>";
export const EMPTY_VALUE = "<empty>";
export const WRITE_ONLY_VALUE = "*****";

export const FILE_PREVIEW_MAX_SIZE = 524288; // 512 KB
